import { render, staticRenderFns } from "./CategoriseConfig.view.vue?vue&type=template&id=9cea68fe&scoped=true&"
import script from "./CategoriseConfig.view.vue?vue&type=script&lang=js&"
export * from "./CategoriseConfig.view.vue?vue&type=script&lang=js&"
import style0 from "./CategoriseConfig.view.vue?vue&type=style&index=0&id=9cea68fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cea68fe",
  null
  
)

export default component.exports